// extracted by mini-css-extract-plugin
export default {"container":"j4-z","heading":"k4-z","links":"l4-z","copy":"m4-z","subCopy":"n4-z","linksLeft":"o4-z","linksCenter":"p4-z","linksRight":"q4-z","link":"r4-z","onlyLink":"s4-z"};